<template lang="pug">
    .div
        #header-box(style)
            #logo-box
                img.logo(src='../assets/car-logo.png', alt='')
          
    </template>

<script>
export default {
    name: 'HeaderPublicComponent'

};
</script>

<style scoped>
#header-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    background-color: var(--primary-gray) !important;

    height: 110px;
    width: 100%;
}

.logo {
    height: 110px;
    padding: 10px 0 10px 35px;
    background-size: contain;
}
</style>